import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

let allLinks: HTMLAnchorElement[] = [];
let shouldZoomIntoImage = false;

function checkImageSize(image: HTMLImageElement, parent: HTMLAnchorElement) {
  if (!image.complete) {
    image.addEventListener('load', () => checkImageSize(image, parent));
    return;
  }
  if (image.width < image.naturalWidth || image.height < image.naturalHeight) {
    parent.classList.remove('oc-imageLink--disabled');
  } else {
    parent.classList.add('oc-imageLink--disabled');
  }
}

export function checkImagesSizes(links: HTMLAnchorElement[] = allLinks) {
  links.forEach((link) => {
    const image = link.firstChild as HTMLImageElement;
    checkImageSize(image, link);
  });
}

const onResizeHandler = () => checkImagesSizes();

export function wrap(image: HTMLImageElement) {
  const link = document.createElement('a');
  link.href = image.src;
  link.classList.add('oc-imageLink');

  image.parentNode?.insertBefore(link, image);
  link.appendChild(image);

  if (shouldZoomIntoImage) {
    link.setAttribute('data-fancybox', '');
    link.setAttribute('data-caption', image.alt);
  }

  return link;
}

function init(domContainer: HTMLElement) {
  shouldZoomIntoImage = 'shouldzoomintoimage' in (domContainer.dataset || {});

  if (shouldZoomIntoImage) {
    const style = document.createElement('style');
    style.textContent = '.fancybox__container { z-index: 1200 !important; }';
    document.head.appendChild(style);

    Fancybox.bind(domContainer, '[data-fancybox]', {
      Images: { zoom: false },
    } as any);
  }

  allLinks = Array.from(domContainer.querySelectorAll('figure img')).map((img) =>
    wrap(img as HTMLImageElement)
  );

  window.addEventListener('resize', onResizeHandler);
  window.addEventListener('orientationchange', onResizeHandler);

  checkImagesSizes();
  return allLinks;
}

function clear() {
  window.removeEventListener('resize', onResizeHandler);
  window.removeEventListener('orientationchange', onResizeHandler);
  allLinks = [];
}

export const initImages = (domContainer: HTMLElement) => init(domContainer);
export default { zoom: { init, clear }, init: initImages };
